import intlMessagesEN from "./i18n/localization/en.json";
import intlMessagesVi from "./i18n/localization/vi.json";
import initReducer from "./Store/initReducer";

export default {
  name: "Topic",
  dir: "Topic",
  pathRoot: "topic",
  routes: [
    {
      url: ":id",
      component: "Page/CreateEdit",
      meta: {
        authRoute: true,
      },
      props: {
        title: "Cập nhật môn học | Trắc nghiệm toàn diện",
        titleI18n: "Topic:updateTopic",
      },
    },
    {
      url: "",
      component: "Page",
      meta: {
        authRoute: true,
      },
      props: {
        title: "Môn học | Trắc nghiệm toàn diện",
        titleI18n: "Topic:titleTopic",
      },
    },
  ],
  lang: { vi: intlMessagesVi, en: intlMessagesEN },
  isAuthenticate: true,
  redux: initReducer,
  role: ["quickquiZFullRole", "CTV"],
};
